export default __webpack_public_path__ + "static/media/globe.cda8cbc8.png";